/**
 * Left Navigation Submenu Mapping Info: a map to matain the UNION & FIND
 *    Key: URLs which belong to the Submenu. 
 *         Type: String
 *    Value: Submenu Intem Name refers to DB Table: NAV_MENU, Column: Menu_NAME2. 
 *           Type: String (One to One) or List (One to Many)
 * Ex.  
 *    As PSOPPC Admin, /manage/authorization is under Organizations
 *    As PSO ADmin, /manage/authorization is under Vendor Authorization
 */
const LEFT_NAV_MAP = new Map();
/* CDA Batch Detail*/
LEFT_NAV_MAP.set("/eventDataSubmission/displayBatchDetail", "CDA Data Submission");
/* Alt Batch Detail*/
LEFT_NAV_MAP.set("/eventDataSubmission/altBatchDetail", "Alternate Data Submission");
/**Manage User */
LEFT_NAV_MAP.set("/manage/viewUser", "Users");
LEFT_NAV_MAP.set("/manage/createUser", "Users");
LEFT_NAV_MAP.set("/manage/editUser", "Users");
/*Organization*/
//PSO
LEFT_NAV_MAP.set("/manage/PSO/viewOrganization", "Organizations");
LEFT_NAV_MAP.set("/manage/PSO/createOrganization", "Organizations");
LEFT_NAV_MAP.set("/manage/PSO/editOrganization", "Organizations");
//Admin
LEFT_NAV_MAP.set("/manage/Admin/viewOrganization", "Organizations");
LEFT_NAV_MAP.set("/manage/Admin/editOrganization", "Organizations");
//Vendor
LEFT_NAV_MAP.set("/manage/Vendor/viewOrganization", "Organizations");
LEFT_NAV_MAP.set("/manage/Vendor/createOrganization", "Organizations");
LEFT_NAV_MAP.set("/manage/Vendor/editOrganization", "Organizations");
/* Vendor Auth*/
LEFT_NAV_MAP.set("/manage/authorization", ["Organizations", "Vendor Authorization"]);
LEFT_NAV_MAP.set("/manage/viewVendorAuthorization", ["Organizations", "Vendor Authorization"]);
LEFT_NAV_MAP.set("/manage/addVendorAuthorization", ["Organizations", "Vendor Authorization"]);
LEFT_NAV_MAP.set("/manage/editVendorAuthorization", ["Organizations", "Vendor Authorization"]);
/**Web Service Account */
LEFT_NAV_MAP.set("/manage/editWebServiceAccount", "Web Service Accounts");
/**Documents */
LEFT_NAV_MAP.set("/manage/viewDocument", "Documents");
LEFT_NAV_MAP.set("/manage/createDocument", "Documents");

export default LEFT_NAV_MAP;